var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:[
			'status',
      _vm.id ? `status-${_vm.colorClass}` : ''
    ]},[_c('span',{staticClass:"status-text"},[_vm._v("\n  \t\t"+_vm._s(_vm.status)+"\n  \t")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }